import { InputBaseComponent } from '../input-base.component';
import {
  Component,
  ViewChild,
  ViewContainerRef, ElementRef, AfterViewInit
} from '@angular/core';

import {  FormGroup } from '@angular/forms';

declare var $: any;
@Component({
  selector: 'ct-radio-container',
  templateUrl: './ct-radio-container.component.html',
  styleUrls: ['./ct-radio-container.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
  }
})

export class CtRadioContainerComponent extends InputBaseComponent implements AfterViewInit {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('el') formControl: ElementRef;
  private familyValue: string;
  public isCollapsed = this.getCollapsible();
  private icon: string;
  public collapsible: Boolean;
  public error: Boolean = false;
  private title: string;
  private additionalInformation: string;
  private description: string;
  public dynamicForm: FormGroup;
  public componetsFails: string;
  public idDefault = Math.random();
  getCollapsible(): Boolean { return this.collapsible }
  setCollapsible(collapsible: Boolean): void { this.collapsible = collapsible }
  getIcon(): string { return this.icon }
  setIcon(icon: string): void { this.icon = icon }
  getDescription(): string { return this.description }
  setDescription(description: string): void { this.description = description }
  getAdditionalInformation(): string { return this.additionalInformation }
  setAdditionalInformation(additionalInformation: string): void { this.additionalInformation = additionalInformation }
  getTitle(): string { return this.title }
  setTitle(title: string): void { this.title = title }
  getFamilyValue(): string { return this.familyValue };
  setFamilyValue(familyValue: string): void { this.familyValue = familyValue }
  getFormControl(): any { return this.formControl }
  setComponetsFails(componetsFails: string): void { this.componetsFails = componetsFails }
  getComponetsFails(): any { return this.componetsFails }

  constructor() {
    super();
  }

  public changeCollapsed() {
      this.isCollapsed = !this.isCollapsed;
  }

  private ngAfterContentInit(): void {
    this.setProperties(this);
    this.getFamilyValue();
    if(!this.target) return;
    this.paintChildren(this.getMetaData(), this.target);
    this.updateFormElements();
  }

  ngAfterViewInit() {
    if(!this.target) return;
    this.paintChildren(this.getMetaData(), this.target);
  }

  ngOnInit(): void {
    this.setChildrenFamilyValue();
  }

  public updateFormElements(): void {
    try {
      this.dynamicForm.controls = {};
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * It sets the Family Value property of all children of the component to the Family Value  property of the parent.
   * @param {any} component - any = this.getMetaData()
   */
  private setChildrenFamilyValue(component: any = this.getMetaData()): void {
    var count = 0;

    component.models.forEach(function (row) {
      row.models.forEach(function (colum) {
        let errorComponets = [];
        colum.models.forEach(function (radio) {
          if (radio.ctType === "CtRadio") {
            radio.controlProperties.familyValue = component.controlProperties.familyValue
          } else {
            console.error("El componete " + radio.ctType + " no es soportado en un CtRadioContainer")
            errorComponets.push(count);
          }
          count++;
        });

        errorComponets.forEach(function (cont) {
          colum.models;
          let json = {
            "hidden": false,
            "listenedComponentId": "",
            "listenedProperty": "",
            "icon": "",
            "textWhenNull": "xx",
            "id": "lblCtLabel_a7cdb07e",
            "labelValue": "El componete " + colum.models[cont].controlProperties.id + " no es soportado en un CtRadioContainer",
            "modelId": "",
            "styleClass": "th-text-alert",
          }
          colum.models[cont].ctType = "CtLabel";
          delete colum.models[cont].controlProperties;
          let jsonString = json;
          colum.models[cont].controlProperties = jsonString;
        });
      });
    });
  }
}

